import { DataLayer } from '@by-miles/data-layer'

import { quoteId } from '../cache'
import { QuoteDocument, QuoteQuery, QuoteQueryVariables, useCreateQuoteMutation } from '../generated/graphql'

export const useCreateQuote = () => {
  const [createQuote, { loading, error, data }] = useCreateQuoteMutation({
    update: (store, { data }) => {
      const quote = data?.createQuote?.quote
      if (!quote) return
      store.writeQuery<QuoteQuery, QuoteQueryVariables>({
        query: QuoteDocument,
        variables: { id: quote.id },
        data: { quote },
      })
      quoteId(quote.id)

      DataLayer.customEvent({
        eventName: 'create quote',
        section: 'full quote',
        eventType: 'form tracking',
        customerId: quote?.details?.customerId || '',
        make: quote?.details.vehicle.make || '',
        policyType: (quote?.details.policy?.isTrackerless ? 'Trackerless' : 'Tracked') || '',
      })
    },
  })
  return { createQuote, loading, error, data }
}
